

import { useGetDataStartup } from '@/composables/getData.js'
import { useConnectionStore } from '@/stores/connectionStore';
import { v4 as uuidv4 } from 'uuid';

// check startup info every 6 hours
const STARTUP_CHECK_INTERVAL = 21600


function processStartupJsonResponse (json,afterProcessingCallbackRoutine) {
  //console.log(" in callback from startup",json)

  if (json.hasOwnProperty('error')) {
    if (afterProcessingCallbackRoutine != undefined)
      afterProcessingCallbackRoutine(true,json['programRun'],json['error'])
    else
      alert("Connection Error. Program: " + json['programRun'] + "    Message:" + json['error'])
    return;
  }

  const connectionStore = useConnectionStore()

  const isMe = json['isme']
  const isSubscriber = json['sp']
  const subscriberExpireDisplayString = json['expdate']
  const subscriberExpireDate = json['expires']
  const newInfoDate = json['newdate']

  var coordinateLocation = json['coor']
  //console.log("coordinate in start",coordinateLocation)
  if (coordinateLocation != "in" && coordinateLocation != "out" && coordinateLocation != "none")
    coordinateLocation = "in"

  const verified = json['verified']         // y/n
  const coach = json['c']

  const timeNow = Math.floor(Date.now() / 1000)

  connectionStore.setCoordinateLocation(coordinateLocation)
  connectionStore.setIsSubscriber(isSubscriber)
  connectionStore.setSubscriberExpireDate(subscriberExpireDate)
  connectionStore.setSubscriberExpireDisplayString(subscriberExpireDisplayString)
  connectionStore.setLastStartupDate(timeNow)
  connectionStore.setLastNewInfoDate(newInfoDate)
  connectionStore.setEmailVerified(verified)

  const lichessAccessToken = json['t']
  const lichessUserid = json['u']

  //console.log("*** access token in startup",lichessAccessToken,lichessUserid)

  connectionStore.setLichessAccessToken(lichessAccessToken) 
  connectionStore.setLichessUserid(lichessUserid)

  connectionStore.setIsMe(isMe)
  connectionStore.setCoach(coach)

  if (afterProcessingCallbackRoutine != undefined)
    afterProcessingCallbackRoutine(true,null,null)
  
}

export const doStartupCheck = (force,afterProcessingCallbackRoutine) => {
  const connectionStore = useConnectionStore()
  var lastStartupCheck = connectionStore.getLastStartupCheckDate
  const lastNewInfoDate = 4000000000

  const timeNow = Math.floor(Date.now() / 1000)

  if (force)
    lastStartupCheck = 0
  //console.log("TIME NOW ",timeNow,lastStartupCheck)

  // no need to call server, but still need to call the callback routine
  if (timeNow - lastStartupCheck <= STARTUP_CHECK_INTERVAL) {
    //console.log("startup no need to check server", afterProcessingCallbackRoutine)
    if (afterProcessingCallbackRoutine != undefined)
      afterProcessingCallbackRoutine(false,null,null)
    return;
  }

  const uuid = uuidv4().replace(/-/g,"")

  var formData = {
    uuid : uuid
  }

  //console.log("in doStartupCheck")
  useGetDataStartup("chessvis_startup_info.php", formData, processStartupJsonResponse,
                  afterProcessingCallbackRoutine)

}
